module.exports = __webpack_public_path__ + "img/Library Function.3993c42b.svg";